import React from 'react'
import "../Style/Product.css"

import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

const ConnetedFooter = () => {
    const year = new Date().getFullYear();

    return (
        <div>
            <section className='bg-[#F8F8F8]'>
                <div className='py-10 px-5 md:px-20'>
                    <span className='block footer_page_heading'>Grow with Haoda Pay</span>
                    <div className='flex justify-center'>
                        <span className='block footer_content pt-6 pb-8'>
                            Be part of the tribe powering one of the fastest-growing business platforms. At Haoda Pay, we’re on a mission to help SMEs automate their finance and cashflows with innovation and passion.
                        </span>

                    </div>
                    <a href="https://merchant.haodapay.com/login" target='blank'><div className='flex justify-center'>
                        <button className='px-16 sm:text-md md:text-2xl text-[10px] py-4'>Start Your Journey with Us</button>
                    </div></a>
                </div>
            </section>
            <section className='bg-[#140C2C]'>
                <div className='2xl:container mx-auto'>
                <div className='footer_dark_section flex justify-center gap-5 flex-wrap xl:px-20 px-5'>
                    <div className='flex flex-col gap-2'>
                        <span className='footer_dark_heading'>Information</span>
                        <span className='footer_dark_text'>Payment Service Provider</span>
                        <span className='footer_dark_text'>Payouts</span>

                        <span className='footer_dark_text'>Grievance Redressal</span>
                        <span className='footer_dark_text'>Certificates</span>
                        <span className='footer_dark_text'>Disclaimer Policy</span>
                    </div>

                    <div className='flex flex-col gap-2'>
                        <span className='footer_dark_heading'>Useful Links</span>
                        <span className='footer_dark_text'>News</span>
                        <span className='footer_dark_text'>About us</span>

                        <span className='footer_dark_text'>Contact</span>
                        <span className='footer_dark_text'>Privacy Policy</span>
                        <span className='footer_dark_text'>Terms & Conditions</span>
                    </div>

                    <div className='flex flex-col gap-2'>
                        <span className='footer_dark_heading'>Payments</span>
                        <span className='footer_dark_text'>Pricing</span>
                        <span className='footer_dark_text'>Payment Link</span>

                        <span className='footer_dark_text'>Settlements</span>
                        <span className='footer_dark_text'>Refunds</span>
                        <span className='footer_dark_text'>Developers</span>
                    </div>

                    <div className='flex flex-col gap-3 xl:gap-8'>
                        <div className='footer_logo_main'>
                            <img className='footer_logo' src="/images/DarkThemeLogo-10.png" />
                        </div>
                        <div className='footer_subs_text'>Subscribe to our Newsletter</div>
                        <div className='flex'>
                            <input type='text' className='footer_input pl-3 outline-none' />
                            <button className='py-4 subscribe_btn px-3'>Subscripe</button>
                        </div>
                    </div>
                </div>
                <div className="lg:px-20 sm:px-5 md:pb-20 pb-5 flex items-center justify-between text-white opacity-70 py-6">

                    <div className="flex-1 border-t border-gray-400"></div>

                    <div className="px-6 flex text-xs sm:text-md items-center gap-1 sm:gap-4">
                        <span className='block text-xs sm:text-md'>© Copyright Finsweet {year}</span>
                        <FaFacebook className="cursor-pointer hover:text-gray-300" />
                        <FaTwitter className="cursor-pointer hover:text-gray-300" />
                        <FaInstagram className="cursor-pointer hover:text-gray-300" />
                    </div>

                    <div className="flex-1 border-t border-gray-400"></div>
                </div>
                </div>
            </section>
        </div>
    )
}

export default ConnetedFooter